import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	routingRuleCreated: {
		id: 'eoc.routing-rules.flag.routing-rule-created.no-translate',
		defaultMessage: `Routing rule{name, select,
      false {}
      other { "{name}"}
    } added.`,
		description:
			'Title of success message that will be displayed in the flag after routing rule created',
	},
	routingRuleUpdated: {
		id: 'eoc.routing-rules.flag.routing-rule-updated.no-translate',
		defaultMessage: `Routing rule{name, select,
      false {}
      other { "{name}"}
    } saved.`,
		description:
			'Title of success message that will be displayed in the flag after routing rule updated',
	},
	routingRuleDeleted: {
		id: 'eoc.routing-rules.flag.routing-rule-deleted.no-translate',
		defaultMessage: `Routing rule{name, select,
      false {}
      other { "{name}"}
    } deleted.`,
		description:
			'Title of success message that will be displayed in the flag after routing rule updated',
	},
	defaultRoutingRuleUpdated: {
		id: 'eoc.routing-rules.flag.default-routing-rule-updated.no-translate',
		defaultMessage: 'Routing rule updated.',
		description:
			'Title of success message that will be displayed in the flag after default routing rule updated',
	},
	reorderError: {
		id: 'eoc.routing-rules.flag.reorder-error.no-translate',
		defaultMessage: `We couldn't reorder routing rules`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while reordering the routing rules',
	},
	deleteError: {
		id: 'eoc.routing-rules.flag.delete-error.no-translate',
		defaultMessage: `We couldn't delete the routing rule`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while deleting the routing rule',
	},
	updateError: {
		id: 'eoc.routing-rules.flag.update-error.no-translate',
		defaultMessage: `We couldn't update the routing rule`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while updating the routing rule',
	},
	createError: {
		id: 'eoc.routing-rules.flag.create-error.no-translate',
		defaultMessage: `We couldn't create the routing rule`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while creating the routing rule',
	},
	saveViewError: {
		id: 'eoc.routing-rules.flag.save-view-error.no-translate',
		defaultMessage: `We couldn't save the view preferences`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while saving the view preferences',
	},
	refresh: {
		id: 'eoc.routing-rules.flag.refresh.no-translate',
		defaultMessage: `Refresh`,
		description: 'Label of first action button inside flag',
	},
});

export default messages;
